import { render } from "./TermsTab.vue?vue&type=template&id=a918e334&scoped=true"
import script from "./TermsTab.vue?vue&type=script&lang=js"
export * from "./TermsTab.vue?vue&type=script&lang=js"

import "./TermsTab.vue?vue&type=style&index=0&id=a918e334&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a918e334"]])

export default __exports__